import React, { Fragment } from 'react';
import {
  Labeled,
  TextField,
  SelectField,
  BooleanField,
} from 'react-admin';

import '../styles.css';
import { annualIncomeChoices, netWorthChoices } from '../../../helpers/mappings';

export default (props) => {
  const { record } = props;
  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: '50%' }}>
            <Labeled label="Employment Status">
              <TextField source="employment.employmentStatus" record={record} />
            </Labeled>
          </td>
          <td style={{ width: '50%' }}>
            {record.employment && ['Employed', 'Self-Employed'].includes(record.employment.employmentStatus) &&
            <Labeled label="Employer Name">
              <TextField source="employment.employerName" record={record} />
            </Labeled>}
          </td>
        </tr>
        {record.employment && ['Employed', 'Self-Employed'].includes(record.employment.employmentStatus) &&
        <Fragment>
          <tr>
            <td>
              <Labeled label="Occupation Type">
                <TextField source="employment.occupationType" record={record} />
              </Labeled>
            </td>
            <td>
              <Labeled label="Employer Address (Line 1)">
                <TextField source="employment.employerAddress.line1" record={record} />
              </Labeled>
            </td>
          </tr>
          <tr>
            <td>
              <Labeled label="Employer Address (Line 2)">
                <TextField source="employment.employerAddress.line2" record={record} />
              </Labeled>
            </td>
            <td>
              <Labeled label="Employer City">
                <TextField source="employment.employerAddress.city" record={record} />
              </Labeled>
            </td>
          </tr>
          <tr>
            <td>
              <Labeled label="Employer Country">
                <TextField source="employment.employerAddress.country" record={record} />
              </Labeled>
            </td>
            <td>
              <Labeled label="Employer State">
                <TextField source="employment.employerAddress.state" record={record} />
              </Labeled>
            </td>
          </tr>
          <tr>
            <td>
              <Labeled label="Employer Zip Code">
                <TextField source="employment.employerAddress.zipcode" record={record} />
              </Labeled>
            </td>
          </tr>
        </Fragment>}
        <tr>
          <td>
            <Labeled label="Annual Income">
              <SelectField className="normalField" source="finances.annualIncome" choices={annualIncomeChoices} record={record} />
            </Labeled>
          </td>
          <td>
            <Labeled label="Liquid Net Worth">
              <SelectField className="normalField" source="finances.liquidNetWorth" choices={netWorthChoices} record={record} />
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <Labeled label="Total Net Worth">
              <SelectField className="normalField" source="finances.totalNetWorth" choices={netWorthChoices} record={record} />
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <Labeled label="Is FINRA Affiliated">
              <BooleanField className="normalField" source="disclosures.finraAffiliated" record={record} />
            </Labeled>
          </td>
          <td>
            <Labeled label="Is an Officer/Board Member or 10% Holder of a Public Company">
              <BooleanField source="disclosures.directorOrTenPercentShareholder" record={record} />
            </Labeled>
          </td>
        </tr>
      </tbody>
    </table>
  );
};



// WEBPACK FOOTER //
// ./src/components/User/children/EmploymentFinances.jsx